import Account from './account'
import Balance from './balance'
import Home from './home'
import Order from './order'
import Recharge from './recharge'

const routes = [...Home, ...Recharge, ...Order, ...Balance, ...Account]

export default routes
